import Component from '../core/Component'

export default class FormNewsletter extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            input: null,
            error: null,
            confirmation: null,
        }
    }

    prepare() {
        this.ref.input.addEventListener('nette:invalid', this.handleInvalid)
        this.ref.input.addEventListener('nette:valid', this.handleValid)

        if (this.ref.confirmation) {
            const modal = Component.getFromElement('modal-newsletter')

            if (modal) {
                modal.open()
            }
        }
    }

    handleInvalid = (event) => {
        console.log('Form invalid', event.target)
        event.preventDefault()

        const element = event.target

        const errorElement = document.createElement('p')
        errorElement.className = 'InputError'
        errorElement.innerHTML = element.getAttribute('data-nette-error')
        errorElement.id = 'error-' + Date.now()
        errorElement.setAttribute('role', 'alert')

        this.ref.error.innerHTML = ''
        this.ref.error.appendChild(errorElement)
        element.setAttribute('aria-invalid', 'true')
        element.setAttribute('aria-describedby', errorElement.id)
        element.classList.add('has-error')
        element.classList.remove('is-valid')
    }

    handleValid = (event) => {
        console.log('Form valid', event.target)
        event.preventDefault()
        const element = event.target

        if (element.tagName.toLowerCase() != 'button') {
            element.removeAttribute('aria-invalid')
            element.removeAttribute('aria-describedby')
            this.ref.error.innerHTML = ''
        }

        element.classList.remove('has-error')
        element.classList.add('is-valid')
    }
}
